import { useLazyQuery } from '@apollo/client';
import { QUERY_AB_TEST_PROB } from '../../graphql/ab-test-queries';

export default function useGetProbabilityTest() {
    const [getProbTest, { data, loading }] = useLazyQuery(QUERY_AB_TEST_PROB);
    return { getProbTest, data, loading };
}
